

import React from 'react';
import '../../styles/blog.css';

import videoImg from '../../images/video.png';




const Blog = () => {
    return ( 
    <section  id="blog" className="blog">
        <div className="container">
            <div className="blog_top-content">
                <h2>Let's have a look from our
                    <span className="highlight"> recent blog</span>
                </h2>
            </div>

            <div className="blog_wrapper">
                
           
            <div className="blog_item">
                    <h3> Poster</h3>
                    <div className="blog_img">
                        <img src={videoImg} alt="" />
                    </div>
                    <p className="description blog_desc">
                      Learn more about us
                    </p>
                    <div>
                        <a href="#" className="learn_more">
                        <i class="ri-arrow-right-line"></i>
                        </a>
                    </div>
                   </div>

                   
                </div>

                </div>

                
 
    </section>

           
    );
};

export default Blog